import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';

import { LibraryCacheEntry, LibraryCacheKey } from 'app/shared/graph';
import { environment } from 'environments/environment';

import { LibraryCacheService } from './library-cache.service';


export interface LibraryCacheEntryDetailDialogData {
    cacheEntry: LibraryCacheKey;
}

@Component({
    imports: [
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        JsonPipe,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './library-cache-entry-detail-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './library-cache-entry-detail-dialog.component.scss'
})
export class LibraryCacheEntryDetailDialogComponent implements OnInit {
    private readonly libraryCacheService = inject(LibraryCacheService);
    readonly data = inject<LibraryCacheEntryDetailDialogData>(MAT_DIALOG_DATA);

    public cacheEntry?: LibraryCacheEntry;
    public loading = false;
    public gitUrl = '';
    public ecbUrl = '';


    ngOnInit(): void {
        this.loading = true;
        this.libraryCacheService.getLibraryCacheEntry(this.data.cacheEntry.key).subscribe(
            {
                next: value => {
                    this.loading = false;
                    this.cacheEntry = value ?? undefined;
                    const owner = this.data.cacheEntry.key.split('/').slice(1, 2).join('');
                    const resource = this.data.cacheEntry.key.split('/').slice(2).filter(x => x.indexOf('=') === -1).join('/');
                    this.gitUrl = this.getGitlabUrl(owner, resource);
                    let baseUrl: string;
                    if (this.data.cacheEntry.resource.startsWith('api')) {
                        baseUrl = `${environment.hub.ecbUrl}/${this.data.cacheEntry.resource}`;
                    } else {
                        baseUrl = `${environment.hub.ecbUrl}/lib/${this.data.cacheEntry.resource}`;
                    }
                    this.ecbUrl = `${baseUrl}?${this.data.cacheEntry.options.map(option => {
                        let { name, value } = option;
                        if (name === 'lazyLoad' || name === 'skipResources') {
                            return name + '=' + (value != '0').toString();
                        } else if (name == 'formatUrl') {
                            const valueSplit = value.split(':');
                            const owner = valueSplit[0];
                            const pkg = valueSplit[1];
                            const resource = valueSplit.slice(2, valueSplit.length).join('/');
                            return name + '=' + encodeURIComponent(`$(package:${owner}/${pkg})/${resource}`);
                        } else {
                            return name + '=' + encodeURIComponent(value);
                        }
                    }).join('&')}`;
                },
                error: err => {
                    this.loading = false;
                }
            }
        );
    }

    getGitlabUrl(owner: string, resource: string): string {
        let group = 'librairies';
        if (owner === 'mediaclip' || owner === 'mediaclip-tests' || owner === 'mediaclip-demo' || owner === 'mediaclip-fonts') {
            group = 'mediaclip';
        }
        if (resource.startsWith('/')) {
            resource = resource.substring(1);
        }

        return `https://git.mediacliphub.com/${group}/${owner}/-/tree/master/${resource}`;
    }

    getGitlabUrlForPath(path?: string | null): string | undefined {
        if (!path) {
            return undefined;
        }
        let url = new URL(path);
        return this.getGitlabUrl(url.hostname, url.pathname);
    }
}
